import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-js-pagination';
import { toast } from 'react-toastify';
import { Spinner, Modal, Button } from 'react-bootstrap';
import { yeuCauPagingAction, deleteYeuCauAction, filterListYeuCau, yeuCauGetFilesAction, yeuCauGetItemAction } from '@store/reducers/yeucau';
import { linhVucGetAllAction } from '@store/reducers/linhvuc';
import { loaiYeuCauGetAllAction } from '@store/reducers/loaiyeucau';
import { khoaGetAllAction } from '@store/reducers/khoa';
import { nhanVienGetAllAction } from '../../store/reducers/nhanVien';
import { nguoiPhoiHopGetAllAction } from '../../store/reducers/nguoiphoihop';
import { getNguoiDungByAccountId, getNguoiDungById } from '@store/reducers/nguoidung';
import { getYeuCauSummaryAction, getYeuCauBreakdownAction, clearThongKe } from '@store/reducers/thongke';
import { createUrlWithParam, getInfomationAccountFromToken } from '../../utils/helper'; //mới thêm mặc định xem tất cả của admin và phụ trách bộ phận
import { URI_INTERNAL } from '../../utils/pathLocations';
import { objectShowNumber, messageToast, rangeDateReport } from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { mapTrangThaiYeuCauLabel, mapMucDoUuTienLabel, TRANG_THAI_YEU_CAU_OPTIONS } from '@app/store/constants';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import * as moment from 'moment';
import Select from 'react-select';
import { Get } from '../../utils/httpProvider';
import { NGUOIDUNG_API, YEUCAU_API, BaseGatewayImage } from '../../utils/apiUrl';
import { fetchWithAuth } from '@app/utils/httpClient';
import StatisticControls from '../../components/statistic-controls/StatisticControls';
import {
    mapLoaiLoiLabel,
    mapMucDoPhucTapLabel,
    LOAI_LOI_OPTIONS,
    MUC_DO_PHUC_TAP_OPTIONS,
    MUC_DO_UU_TIEN
} from '@app/store/constants';
import { downloadFileByUrls } from '@app/utils/fileDownload';
import { userManager } from '@app/utils/oidc';
import { Dropdown } from 'react-bootstrap';

const YeuCau = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const listLoading = useSelector(state => state.yeuCau.loadingPaging);

    const valueSearch = useSelector(state => state.search.valueSearch);
    const totalYeuCau = useSelector(state => state.yeuCau.totalYeuCau);
    const listYeuCau = useSelector(state => state.yeuCau.listYeuCau);

    const listLinhVuc = useSelector(state => state.linhvuc.listLinhVuc || []);
    const listLoaiYeuCau = useSelector(state => state.loaiyeucau.listLoaiYeuCau || []);
    const listKhoa = useSelector(state => state.khoa.listKhoa || []);
    const listNguoiPhoiHop = useSelector((state) => state.nguoiPhoiHop.listNguoiPhoiHop || []);
    const listNhanVien = useSelector((state) => state.nhanVien.list || []);

    // ===== CURRENT USER (CỦA TÔI) =====
    const [accountId, setAccountId] = useState(null);
    const [myNguoiDungId, setMyNguoiDungId] = useState(null);
    const [myNguoiDungName, setMyNguoiDungName] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false); // mới thêm mặc định xem tất cả của admin và phụ trách bộ phận
    const didInitMineRef = useRef(false);

    // pagination & search
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    // username map
    const [userNameMap, setUserNameMap] = useState({});
    // tránh nháy ID: loading theo từng nguoiDungId
    const [loadingUserIds, setLoadingUserIds] = useState({});

    // chống gọi trùng khi listYeuCau thay đổi nhanh
    const inFlightUserIdsRef = useRef(new Set());

    // nếu fetch không ra tên thì đánh dấu để khỏi fetch lặp vô hạn
    const notFoundUserIdsRef = useRef(new Set());


    // filters (now support multi-value arrays)
    const [filterLinhVuc, setFilterLinhVuc] = useState([]);
    const [filterLoaiYeuCau, setFilterLoaiYeuCau] = useState([]);
    const [filterStatus, setFilterStatus] = useState([]);
    const [filterKhoa, setFilterKhoa] = useState([]);
    const [filterNguoiDung, setFilterNguoiDung] = useState([]);
    const [filterNhanVienThucHien, setFilterNhanVienThucHien] = useState([]);
    const [dates, setDates] = useState({ startDate: null, endDate: null });
    const [selectedNguoiDungOption, setSelectedNguoiDungOption] = useState(null);
    const [filterMucDoPhucTap, setFilterMucDoPhucTap] = useState([]);
    const [filterMucDoUuTien, setFilterMucDoUuTien] = useState([]);
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    // quick search debounce
    const quickSearchTimeoutRef = useRef(null);

    const buildCurrentFilters = useCallback(() => {
        return {
            linhVucId: filterLinhVuc,
            loaiYeuCauId: filterLoaiYeuCau,
            status: filterStatus,
            khoaId: filterKhoa,
            mucDoPhucTap: filterMucDoPhucTap,
            mucDoUuTien: filterMucDoUuTien,
            nguoiDungId: filterNguoiDung,
            nhanVienThucHienId: filterNhanVienThucHien,
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        };
    }, [
        filterLinhVuc,
        filterLoaiYeuCau,
        filterStatus,
        filterKhoa,
        filterMucDoPhucTap,
        filterMucDoUuTien,
        filterNguoiDung,
        filterNhanVienThucHien,
        dates
    ]);

    useEffect(() => {
        return () => {
            if (quickSearchTimeoutRef.current) clearTimeout(quickSearchTimeoutRef.current);
        };
    }, []);

    const handleQuickSearchChange = (e) => {
        const v = (e.target.value || '').toString();
        setSearch(v);
        setPage(1);

        if (quickSearchTimeoutRef.current) clearTimeout(quickSearchTimeoutRef.current);

        quickSearchTimeoutRef.current = setTimeout(() => {
            fetchData(1, pageSize, v, buildCurrentFilters(), true);
        }, 250);
    };

    const clearQuickSearch = () => {
        setSearch('');
        setPage(1);

        if (quickSearchTimeoutRef.current) clearTimeout(quickSearchTimeoutRef.current);

        fetchData(1, pageSize, '', buildCurrentFilters(), true);
    };

    // add view state
    const [viewMode, setViewMode] = useState('list');
    const [groupBy, setGroupBy] = useState('day');

    const thongKeState = useSelector(state => state.thongKe || {});

    // Normalize summary and breakdown lists (from thunk state)
    const yeuCauSummaryList = Array.isArray(thongKeState.yeuCauSummary) ? thongKeState.yeuCauSummary : (thongKeState.yeuCauSummary && Array.isArray(thongKeState.yeuCauSummary.data) ? thongKeState.yeuCauSummary.data : []);
    const yeuCauBreakdownList = Array.isArray(thongKeState.yeuCauBreakdown) ? thongKeState.yeuCauBreakdown : (thongKeState.yeuCauBreakdown && Array.isArray(thongKeState.yeuCauBreakdown.data) ? thongKeState.yeuCauBreakdown.data : []);

    // Summary selection and live search (match HoTro.js behavior)
    const [selectedSummaryIds, setSelectedSummaryIds] = useState([]);
    const [summarySearch, setSummarySearch] = useState('');

    const filteredSummary = useMemo(() => {
        const rows = yeuCauSummaryList || [];
        const q = (summarySearch || '').trim().toLowerCase();
        if (!q) return rows;
        return rows.filter(r => {
            const name = (r.tenNguoiDung || r.ten || r.nguoiDungName || r.nguoiDungId || '').toString().toLowerCase();
            return name.includes(q);
        });
    }, [yeuCauSummaryList, summarySearch]);

    useEffect(() => { setSelectedSummaryIds([]); }, [yeuCauSummaryList, viewMode]);

    const toggleSelect = (id) => {
        const key = String(id);
        setSelectedSummaryIds(prev => {
            const s = new Set(prev || []);
            if (s.has(key)) s.delete(key); else s.add(key);
            return Array.from(s);
        });
    };

    useEffect(() => {
        let mounted = true;

        (async () => {
            try {
                const user = await userManager.getUser();

                // detect admin-like roles (admin or "Phụ trách bộ phận") // mới thêm mặc định xem tất cả của admin và phụ trách bộ phận
                try {
                    const normalize = (s) => (s || '').toString().toLowerCase().trim();
                    let rolesArr = [];
                    const profileRoles = user?.profile?.role || user?.profile?.roles || null;
                    if (profileRoles) {
                        if (Array.isArray(profileRoles)) rolesArr = profileRoles.map(r => normalize(r));
                        else rolesArr = normalize(profileRoles).split(/[;,]/).map(r => r.trim()).filter(Boolean);
                    } else {
                        const info = getInfomationAccountFromToken();
                        const tokenRoles = info?.role || info?.roles || null;
                        if (tokenRoles) {
                            if (Array.isArray(tokenRoles)) rolesArr = tokenRoles.map(r => normalize(r));
                            else rolesArr = normalize(tokenRoles).split(/[;,]/).map(r => r.trim()).filter(Boolean);
                        }
                    }

                    const adminLike = rolesArr.includes('admin') || rolesArr.includes('manager') || rolesArr.includes('phụ trách bộ phận') || rolesArr.includes('phu trach bo phan');
                    if (mounted) setIsAdmin(Boolean(adminLike));
                } catch (e) { /* ignore role detection errors */ }

                const idFromUser =
                    user?.profile?.sub ||
                    user?.profile?.accountId ||
                    user?.profile?.nameid ||
                    null;

                const nameFromUser =
                    user?.profile?.name ||
                    user?.profile?.preferred_username ||
                    user?.profile?.email ||
                    null;

                if (mounted && idFromUser) {
                    setAccountId(String(idFromUser));
                    if (nameFromUser) setMyNguoiDungName(String(nameFromUser));

                    try {
                        const payload = await dispatch(getNguoiDungByAccountId(idFromUser)).unwrap();

                        let item = payload || null;
                        if (Array.isArray(item)) item = item[0] || null;
                        if (item && item.data) item = item.data;
                        if (Array.isArray(item)) item = item[0] || null;
                        if (item && item.data) item = item.data;

                        const foundId = item?.id || item?.nguoiDungId;
                        const foundName = item?.hoTen || item?.fullName;

                        if (mounted && foundId) setMyNguoiDungId(String(foundId));
                        if (mounted && foundName) setMyNguoiDungName(String(foundName));

                        // đổ luôn vào userNameMap để list hiển thị tên ngay
                        if (mounted && foundId && foundName) {
                            setUserNameMap(prev => ({ ...prev, [String(foundId)]: foundName }));
                        }
                    } catch { }
                }
            } catch { }
        })();

        return () => { mounted = false; };
    }, [dispatch]);

    useEffect(() => {
        if (viewMode !== 'list') return; // only apply in list view
        if (didInitMineRef.current) return;

        const sp = new URLSearchParams(location.search || '');
        const hasNguoiDungParam = sp.get('nguoiDung') || sp.get('nguoidung') || sp.get('nguoiDungId');

        // If URL explicitly sets nguoiDung -> respect it and don't auto-initialize
        if (hasNguoiDungParam) {
            didInitMineRef.current = true;
            return;
        }

        // If admin-like -> show all
        if (isAdmin) {
            didInitMineRef.current = true;
            onShowAll();
            return;
        }

        // Otherwise, if we have mapped myNguoiDungId -> show mine
        if (myNguoiDungId) {
            didInitMineRef.current = true;
            onShowMine();
            return;
        }

        // else: wait until isAdmin or myNguoiDungId becomes available
    }, [isAdmin, myNguoiDungId, location.search, viewMode]);


    const toggleSelectAll = () => {
        const currentIds = filteredSummary.map(i => String(i.nguoiDungId || i.nguoiDung || '')).filter(Boolean);
        if (currentIds.length === 0) return;
        const allSelected = currentIds.every(id => selectedSummaryIds.includes(id));
        if (allSelected) {
            setSelectedSummaryIds(prev => (prev || []).filter(id => !currentIds.includes(id)));
        } else {
            setSelectedSummaryIds(prev => Array.from(new Set([...(prev || []), ...currentIds])));
        }
    };

    // add state
    const [selectedUserForBreakdown, setSelectedUserForBreakdown] = useState(null);

    // files state
    const filesByYeuCau = useSelector(state => state.yeuCau.filesByYeuCau || {});
    const loadingFiles = useSelector(state => state.yeuCau.loadingFiles || false);

    // modal state for files
    const [filesModalOpen, setFilesModalOpen] = useState(false);
    const [filesModalYeuCauId, setFilesModalYeuCauId] = useState(null);
    // detail modal (new) - view details inline without navigation
    const [detailModalOpen, setDetailModalOpen] = useState(false);
    const [detailModalLoading, setDetailModalLoading] = useState(false);
    const [detailModalItem, setDetailModalItem] = useState(null);
    const [detailModalSidebarWidth, setDetailModalSidebarWidth] = useState(0);

    useEffect(() => {
        const updateDetailModalSidebarWidth = () => {
            const sidebar = document.querySelector('.main-sidebar');
            const width = sidebar ? Math.round(sidebar.getBoundingClientRect().width) : 0;
            setDetailModalSidebarWidth(width);
        };

        updateDetailModalSidebarWidth();
        window.addEventListener('resize', updateDetailModalSidebarWidth);

        return () => {
            window.removeEventListener('resize', updateDetailModalSidebarWidth);
        };
    }, []);

    useEffect(() => {
        document.documentElement.style.setProperty(
            '--yeucau-detail-sidebar-width',
            `${detailModalSidebarWidth}px`
        );

        return () => {
            document.documentElement.style.removeProperty('--yeucau-detail-sidebar-width');
        };
    }, [detailModalSidebarWidth]);

    const openFilesModal = async (yeuCauId) => {
        setFilesModalYeuCauId(yeuCauId);
        setFilesModalOpen(true);
        try {
            await dispatch(yeuCauGetFilesAction(yeuCauId));
        } catch (e) {
            // ignore
        }
    };

    const closeFilesModal = () => {
        setFilesModalOpen(false);
        setFilesModalYeuCauId(null);
    };

    const openDetailModal = async (yeuCauId) => {
        setDetailModalOpen(true);
        setDetailModalLoading(true);
        setDetailModalItem(null);
        try {
            // try to get item payload from thunk
            const res = await dispatch(yeuCauGetItemAction(yeuCauId));
            // res may be action object; try to extract payload
            let payload = res && (res.payload || res) || null;
            if (payload && payload.data) payload = payload.data;
            if (Array.isArray(payload)) payload = payload[0] || null;
            setDetailModalItem(payload || null);
        } catch (e) {
            // ignore
            setDetailModalItem(null);
        }

        try {
            await dispatch(yeuCauGetFilesAction(yeuCauId));
        } catch (_) { }

        setDetailModalLoading(false);
    };

    const closeDetailModal = () => {
        setDetailModalOpen(false);
        setDetailModalItem(null);
        setDetailModalLoading(false);
    };

    //hien số đếm tệp 
    const requestedFilesRef = useRef(new Set());

    useEffect(() => {
        if (!Array.isArray(listYeuCau) || listYeuCau.length === 0) return;

        listYeuCau.forEach((yc) => {
            const id = yc?.id;
            if (!id) return;

            // đã có trong store thì không gọi nữa
            if (Array.isArray(filesByYeuCau[id])) return;

            // tránh gọi lặp nhiều lần
            if (requestedFilesRef.current.has(id)) return;
            requestedFilesRef.current.add(id);

            dispatch(yeuCauGetFilesAction(id));
        });
    }, [listYeuCau, filesByYeuCau, dispatch]);


    // Files are served from public gateway; construct URL and let browser handle download
    const makeFileUrl = (fileUrl) => (
        fileUrl && fileUrl.startsWith('http') ? fileUrl : `${BaseGatewayImage}${fileUrl || ''}`
    );

    // Helpers to detect extension and decide inline preview vs download
    const getFileExt = (f) => {
        const raw = (f?.name || f?.fileName || f?.fileUrl || '').toString().toLowerCase();
        const clean = raw.split('?')[0].split('#')[0];
        const i = clean.lastIndexOf('.');
        return i >= 0 ? clean.slice(i + 1) : '';
    };

    const INLINE_PREVIEW_EXTS = new Set([
        'png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'pdf'
    ]);

    const canInlinePreview = (f) => INLINE_PREVIEW_EXTS.has(getFileExt(f));

    const handleDownloadYeuCauFile = async (f) => {
        try {
            const urls = [YEUCAU_API.DOWNLOAD_FILE(f.id)];
            await downloadFileByUrls(urls, f.name || f.fileName || 'tep-dinh-kem');
        } catch (e) {
            console.error('Download error:', e);
            toast.error('Không thể tải tệp. Vui lòng thử lại hoặc liên hệ quản trị.');
        }
    };

    // show summary
    const onShowSummary = async () => {
        setViewMode('summary');
        const params = {
            from: dates.startDate ? dates.startDate.format('YYYY-MM-DD') : null,
            to: dates.endDate ? dates.endDate.format('YYYY-MM-DD') : null,
            linhVucId: filterLinhVuc || null,
            khoaId: filterKhoa || null,
            groupBy: groupBy
        };
        if (filterStatus !== undefined && filterStatus !== null && filterStatus.length) params.status = filterStatus;
        await dispatch(getYeuCauSummaryAction(params));
    };

    const onShowList = () => {
        setViewMode('list');
        dispatch(clearThongKe());
    };

    const onShowBreakdownForUser = async (nguoiDungIdOrObj) => {
        // normalize id (accept id string/number or object)
        let id = nguoiDungIdOrObj;
        if (id && typeof id === 'object') {
            id = id.id || id.nguoiDungId || id.accountId || id.userId || null;
        }
        if (!id) return;

        setSelectedUserForBreakdown(id);
        setViewMode('breakdown');
        const params = {
            from: dates.startDate ? dates.startDate.format('YYYY-MM-DD') : null,
            to: dates.endDate ? dates.endDate.format('YYYY-MM-DD') : null,
            groupBy: groupBy,
            nguoiDungId: id
        };
        if (filterStatus !== undefined && filterStatus !== null && filterStatus.length) params.status = filterStatus;
        // include ids so FE can open first item when available
        params.includeIds = true;
        params.maxIds = 50;
        await dispatch(getYeuCauBreakdownAction(params));
    };

    // Navigate from breakdown row to filtered list view
    const goToFilteredList = (nguoiDungId, ngayBatDauFrom, ngayBatDauTo) => {
        const params = { nguoiDung: nguoiDungId };
        if (ngayBatDauFrom) params.ngayBatDauFrom = ngayBatDauFrom;
        if (ngayBatDauTo) params.ngayBatDauTo = ngayBatDauTo;
        history.push(createUrlWithParam(URI_INTERNAL.YEUCAU_PATH, params));
        // ensure UI switches back to list so parsed query applies to list view
        setViewMode('list');
    };

    // reload when groupBy changes
    useEffect(() => {
        if (viewMode === 'breakdown' && selectedUserForBreakdown) {
            const params = {
                from: dates.startDate ? dates.startDate.format('YYYY-MM-DD') : null,
                to: dates.endDate ? dates.endDate.format('YYYY-MM-DD') : null,
                groupBy: groupBy,
                nguoiDungId: selectedUserForBreakdown
            };
            dispatch(getYeuCauBreakdownAction(params));
        }
    }, [groupBy, viewMode, selectedUserForBreakdown]);

    // reload summary when groupBy changes
    useEffect(() => {
        if (viewMode === 'summary') {
            const params = {
                from: dates.startDate ? dates.startDate.format('YYYY-MM-DD') : null,
                to: dates.endDate ? dates.endDate.format('YYYY-MM-DD') : null,
                linhVucId: filterLinhVuc || null,
                khoaId: filterKhoa || null,
                groupBy: groupBy
            };
            dispatch(getYeuCauSummaryAction(params));
        }
    }, [groupBy, viewMode]);

    // ==========================
    // MAP FUNCTIONS
    // ==========================
    const getTenLinhVuc = (id) => {
        const lv = listLinhVuc.find(x => x.id === id);
        return lv ? (lv.name || lv.tenLinhVuc) : 'Không rõ';
    };

    const getTenLoaiYeuCau = (id) => {
        if (!id) return '';
        const item = listLoaiYeuCau.find(x => x.id === id);
        return item ? (item.name || '') : 'Không rõ';
    };

    const getTenKhoa = (ids) => {
        if (!ids || ids.length === 0) return '';
        const names = listKhoa
            .filter(k => ids.includes(k.id))
            .map(k => k.maKhoa || k.name);
        return names.length > 0 ? names.join(', ') : 'Không rõ';
    };

    const getTenNguoiPhoiHop = (ids) => {
        if (!ids || ids.length === 0) return '';
        const names = listNguoiPhoiHop
            .filter(k => ids.includes(k.id))
            .map(k => k.hoTen || k.name);
        return names.length > 0 ? names.join(', ') : 'Không rõ';
    };

    const getTenNhanVienThucHien = (ids) => {
        if (!ids || ids.length === 0) return '';
        const names = listNhanVien
            .filter(k => ids.includes(k.id))
            .map(k => k.hoTen || k.name || k.tenNhanVien || String(k.id))
        return names.length > 0 ? names.join(', ') : 'Không rõ';
    };

    // helper to read status counts from summary item (support dynamic StatusCounts or legacy fields)
    const getStatusCount = (item, key) => {
        if (!item) return 0;
        // preferred object map returned by backend (case-insensitive keys tolerated)
        const map = item.StatusCounts || item.statusCounts || item.StatusCount || item.statusCount || null;
        if (map && typeof map === 'object') {
            if (map[key] !== undefined) return map[key] || 0;
            if (map[String(key)] !== undefined) return map[String(key)] || 0;
            // try matching by normalized key (lowercase)
            const lower = Object.keys(map).find(k => k && k.toLowerCase() === String(key).toLowerCase());
            if (lower) return map[lower] || 0;
        }

        // fallback to legacy named fields
        switch ((key || '').toString()) {
            case 'hoanthanh': return item.completedCount ?? item.CompletedCount ?? 0;
            case 'dangtest': return item.inProgressCount ?? item.InProgressCount ?? 0;
            case 'chophanhoi': return item.waitingCount ?? item.WaitingCount ?? 0;
            case 'chonangcap': return item.upgradeCount ?? item.UpgradeCount ?? 0;
            default: return 0;
        }
    };

    // options
    const linhVucOptions = listLinhVuc.map(lv => ({ value: String(lv.id), label: lv.name || lv.tenLinhVuc }));
    const loaiYeuCauOptions = listLoaiYeuCau.map(item => ({ value: String(item.id), label: item.name || '' }));
    const khoaOptions = listKhoa.map(k => ({ value: String(k.id), label: k.tenKhoa || k.name || k.maKhoa }));
    const trangThaiOptions = TRANG_THAI_YEU_CAU_OPTIONS.map(s => ({ value: s.value, label: s.label }));
    const mucDoPhucTapOptions = MUC_DO_PHUC_TAP_OPTIONS.map(s => ({ value: s.value, label: s.label }));
    const mucDoUuTienOptions = MUC_DO_UU_TIEN.map(s => ({ value: s.value, label: s.label }));
    const nhanVienThucHienOptions = listNhanVien.map(nv => ({
        value: String(nv.id),
        label: nv.hoTen || nv.name || nv.tenNhanVien || String(nv.id)
    }));

    const selectStyles = {
        control: (provided) => ({ ...provided, minHeight: 30, fontSize: 13 }), // Bỏ height
        valueContainer: (provided) => ({ ...provided, padding: '0 8px' }),
        indicatorsContainer: (provided) => ({ ...provided, minHeight: 30 }), // Bỏ height
        input: (provided) => ({ ...provided, margin: 0, padding: 0 }),
        option: (provided) => ({ ...provided, fontSize: 13 })
    };

    const TABLE_HEADER_FOOTER_CELL_STYLE = {
        textAlign: 'center',
        verticalAlign: 'middle'
    };

    // ==========================
    // FETCH DATA (supports filters)
    // ==========================
    const fetchData = useCallback(
        async (Page, Size, Search, Filters = {}, updateUrl = true) => {
            const model = { Keyword: Search, PageIndex: Page, PageSize: Size };

            if (Filters.linhVucId) model.LinhVucId = Filters.linhVucId;
            if (Filters.loaiYeuCauId) model.LoaiYeuCauId = Filters.loaiYeuCauId;
            if (Filters.status !== undefined && Filters.status !== null && Filters.status.length) model.Status = Filters.status.map(s => Number(s));
            if (Filters.khoaId) model.KhoaId = Filters.khoaId;
            if (Filters.nguoiDungId) model.NguoiDungId = Filters.nguoiDungId;
            if (Filters.nhanVienThucHienId) model.NhanVienThucHienId = Array.isArray(Filters.nhanVienThucHienId) ? Filters.nhanVienThucHienId.map(n => Number(n)) : [Number(Filters.nhanVienThucHienId)];
            if (Filters.mucDoPhucTap !== undefined && Filters.mucDoPhucTap !== null && Filters.mucDoPhucTap.length) model.MucDoPhucTap = Filters.mucDoPhucTap.map(v => Number(v));
            if (Filters.mucDoUuTien !== undefined && Filters.mucDoUuTien !== null && Filters.mucDoUuTien.length) model.MucDoUuTien = Filters.mucDoUuTien.map(v => Number(v));
            // format dates as YYYY-MM-DD for backend and for URL (match HoTro.js)
            if (Filters.ngayFrom) model.NgayBatDauFrom = moment(Filters.ngayFrom).format('YYYY-MM-DD');
            if (Filters.ngayTo) model.NgayBatDauTo = moment(Filters.ngayTo).format('YYYY-MM-DD');

            await dispatch(yeuCauPagingAction(model));

            if (listLinhVuc.length === 0) dispatch(linhVucGetAllAction());
            if (listLoaiYeuCau.length === 0) dispatch(loaiYeuCauGetAllAction());
            if (listKhoa.length === 0) dispatch(khoaGetAllAction());
            if (listNguoiPhoiHop.length === 0) dispatch(nguoiPhoiHopGetAllAction());
            if (listNhanVien.length === 0) dispatch(nhanVienGetAllAction());

            if (updateUrl) {
                // sanitize filters to avoid serializing undefined/null values
                const sanitizeArray = (v) => {
                    if (v === undefined || v === null) return null;
                    const arr = Array.isArray(v) ? v : [v];
                    const cleaned = arr
                        .map(x => (x === undefined || x === null ? '' : String(x)))
                        .filter(x => x !== '' && x !== 'undefined' && x !== 'null');
                    return cleaned.length ? cleaned : null;
                };

                const s_linhvuc = sanitizeArray(Filters.linhVucId);
                const s_loai = sanitizeArray(Filters.loaiYeuCauId);
                const s_status = sanitizeArray(Filters.status);
                const s_mucDoPhucTap = sanitizeArray(Filters.mucDoPhucTap);
                const s_mucDoUuTien = sanitizeArray(Filters.mucDoUuTien);
                const s_khoa = sanitizeArray(Filters.khoaId);
                const s_nguoiDung = sanitizeArray(Filters.nguoiDungId);
                const s_nhanVien = sanitizeArray(Filters.nhanVienThucHienId);

                const params = { page: Page, size: Size, search: Search };
                if (s_linhvuc) params.linhvuc = s_linhvuc;
                if (s_loai) params.loaiyeucau = s_loai;
                if (s_status) params.status = s_status;
                if (s_mucDoPhucTap) params.mucDoPhucTap = s_mucDoPhucTap;
                if (s_mucDoUuTien) params.mucDoUuTien = s_mucDoUuTien;
                if (s_khoa) params.khoa = s_khoa;
                if (s_nguoiDung) params.nguoidung = s_nguoiDung;
                if (s_nhanVien) params.nhanVienThucHien = s_nhanVien;
                if (model.NgayBatDauFrom) params.ngayBatDauFrom = model.NgayBatDauFrom;
                if (model.NgayBatDauTo) params.ngayBatDauTo = model.NgayBatDauTo;

                history.replace(createUrlWithParam(URI_INTERNAL.YEUCAU_PATH, params));
            }
        },
        [dispatch, history, listLinhVuc.length, listLoaiYeuCau.length, listKhoa.length, listNguoiPhoiHop.length, listNhanVien.length]
    );

    // ==========================
    // FETCH DISPLAY NAMES FOR NGUOI DUNG
    // ==========================
    useEffect(() => {
        if (!Array.isArray(listYeuCau) || listYeuCau.length === 0) return;

        const ids = Array.from(
            new Set(
                listYeuCau
                    .map(x => x?.nguoiDungId)
                    .filter(Boolean)
                    .map(x => String(x))
            )
        );

        // chỉ fetch các id chưa có tên, chưa in-flight, và chưa bị đánh dấu not found
        const toFetch = ids.filter(id =>
            !userNameMap[id] &&
            !inFlightUserIdsRef.current.has(id) &&
            !notFoundUserIdsRef.current.has(id)
        );

        if (toFetch.length === 0) return;

        // mark loading + in-flight
        toFetch.forEach(id => inFlightUserIdsRef.current.add(id));
        setLoadingUserIds(prev => {
            const next = { ...prev };
            toFetch.forEach(id => { next[id] = true; });
            return next;
        });

        Promise.all(
            toFetch.map(async (id) => {
                // 1) ưu tiên get by NguoiDungId
                try {
                    const res = await dispatch(getNguoiDungById(id)).unwrap();
                    let item = res || null;
                    if (Array.isArray(item)) item = item[0] || null;
                    if (item && item.data) item = item.data;
                    if (Array.isArray(item)) item = item[0] || null;

                    const name =
                        item?.hoTen || item?.fullName || item?.name || item?.ten || item?.displayName || null;

                    return { id: String(id), name };
                } catch { /* ignore */ }

                // 2) fallback get by account id (nếu API bạn có hỗ trợ)
                try {
                    const res2 = await dispatch(getNguoiDungByAccountId(id)).unwrap();
                    let item2 = res2 || null;
                    if (Array.isArray(item2)) item2 = item2[0] || null;
                    if (item2 && item2.data) item2 = item2.data;
                    if (Array.isArray(item2)) item2 = item2[0] || null;

                    const name2 =
                        item2?.hoTen || item2?.fullName || item2?.name || item2?.ten || item2?.displayName || null;

                    return { id: String(id), name: name2 };
                } catch {
                    return { id: String(id), name: null };
                }
            })
        )
            .then(results => {
                setUserNameMap(prev => {
                    const next = { ...prev };

                    results.forEach(r => {
                        const key = String(r.id);
                        if (r?.name) {
                            next[key] = r.name;                 // có tên => cache
                        } else {
                            notFoundUserIdsRef.current.add(key); // không có tên => đánh dấu
                        }
                    });

                    return next;
                });
            })
            .finally(() => {
                setLoadingUserIds(prev => {
                    const next = { ...prev };
                    toFetch.forEach(id => { delete next[id]; });
                    return next;
                });

                toFetch.forEach(id => inFlightUserIdsRef.current.delete(id));
            });

    }, [listYeuCau, dispatch, userNameMap]);


    // when parse URL has nguoiDung id(s), try to fetch display name(s) and set selected option(s)
    useEffect(() => {
        if (!filterNguoiDung || filterNguoiDung.length === 0) return;
        let mounted = true;
        (async () => {
            try {
                const opts = [];
                await Promise.all(filterNguoiDung.map(async id => {
                    try {
                        const res = await Get(NGUOIDUNG_API.GET_BY_ID(id));
                        const item = res && (res.data || res) || null;
                        const u = Array.isArray(item) ? item[0] : item;
                        if (u && mounted) {
                            const opt = { value: String(u.id || u.nguoiDungId || u.accountId || u.userId), label: u.hoTen || u.fullName || u.name || u.ten || u.displayName || (u.id || u.nguoiDungId) };
                            opts.push(opt);
                        }
                    } catch (e) {
                        // ignore
                    }
                }));
                if (mounted) setSelectedNguoiDungOption(opts);
            } catch (e) {
                // ignore
            }
        })();
        return () => { mounted = false; };
    }, [filterNguoiDung]);

    // ==========================
    // PARSE URL (including filters)
    // ==========================
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const pageParam = parseInt(params.get('page') || 1);
        const sizeParam = parseInt(params.get('size') || 20);
        const searchParam = params.get('search') || '';
        const mucDoPhucTapParam = params.getAll('mucDoPhucTap') || [];
        const mucDoUuTienParam = params.getAll('mucDoUuTien') || [];
        // linhvuc may appear multiple times: ?linhvuc=1&linhvuc=2
        const linhvucParam = params.getAll('linhvuc') || [];
        const loaiYeuCauParam = params.getAll('loaiyeucau') || [];
        const statusParam = params.getAll('status') || [];
        const khoaParam = params.getAll('khoa') || [];
        const nguoiDungParam = params.getAll('nguoidung') || params.getAll('nguoiDung') || params.getAll('nguoiDungId') || [];
        const nhanVienThucHienParam = params.getAll('nhanVienThucHien') || params.getAll('nhanVienThucHienId') || [];
        const ngayFromParam = params.get('ngayBatDauFrom') || '';
        const ngayToParam = params.get('ngayBatDauTo') || '';

        if (pageParam !== page) setPage(pageParam);
        if (sizeParam !== pageSize) setPageSize(sizeParam);
        if (searchParam !== search) setSearch(searchParam);

        setFilterLinhVuc(Array.isArray(linhvucParam) ? linhvucParam : (linhvucParam ? [linhvucParam] : []));
        setFilterLoaiYeuCau(Array.isArray(loaiYeuCauParam) ? loaiYeuCauParam : (loaiYeuCauParam ? [loaiYeuCauParam] : []));
        setFilterStatus(Array.isArray(statusParam) ? statusParam : (statusParam ? [statusParam] : []));
        setFilterKhoa(Array.isArray(khoaParam) ? khoaParam : (khoaParam ? [khoaParam] : []));
        setFilterNguoiDung(Array.isArray(nguoiDungParam) ? nguoiDungParam : (nguoiDungParam ? [nguoiDungParam] : []));
        setFilterMucDoPhucTap(Array.isArray(mucDoPhucTapParam) ? mucDoPhucTapParam : (mucDoPhucTapParam ? [mucDoPhucTapParam] : []));
        setFilterNhanVienThucHien(Array.isArray(nhanVienThucHienParam) ? nhanVienThucHienParam : (nhanVienThucHienParam ? [nhanVienThucHienParam] : []));
        setFilterMucDoUuTien(Array.isArray(mucDoUuTienParam) ? mucDoUuTienParam : (mucDoUuTienParam ? [mucDoUuTienParam] : []));
        setDates({ startDate: ngayFromParam ? moment(ngayFromParam) : null, endDate: ngayToParam ? moment(ngayToParam) : null });

        fetchData(pageParam, sizeParam, searchParam, {
            linhVucId: Array.isArray(linhvucParam) ? linhvucParam : (linhvucParam ? [linhvucParam] : []),
            loaiYeuCauId: loaiYeuCauParam,
            status: statusParam,
            khoaId: khoaParam,
            mucDoPhucTap: mucDoPhucTapParam,
            mucDoUuTien: mucDoUuTienParam,
            nguoiDungId: nguoiDungParam,
            nhanVienThucHienId: nhanVienThucHienParam,
            ngayFrom: ngayFromParam ? moment(ngayFromParam).toDate() : null,
            ngayTo: ngayToParam ? moment(ngayToParam).toDate() : null
        }, false);
    }, [location.search, fetchData]);

    // ==========================
    // GLOBAL SEARCH
    // ==========================
    useEffect(() => {
        if (valueSearch && valueSearch !== search) {
            setSearch(valueSearch);
            fetchData(1, pageSize, valueSearch, {
                linhVucId: filterLinhVuc,
                loaiYeuCauId: filterLoaiYeuCau,
                status: filterStatus,
                khoaId: filterKhoa,
                mucDoPhucTap: filterMucDoPhucTap,
                mucDoUuTien: filterMucDoUuTien,
                nguoiDungId: filterNguoiDung,
                nhanVienThucHienId: filterNhanVienThucHien,
                ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
                ngayTo: dates.endDate ? dates.endDate.toDate() : null
            }, true);
            setPage(1);
        }
    }, [valueSearch, pageSize, search, fetchData]);

    // ==========================
    // PAGINATION
    // ==========================
    const changePage = (number) => {
        setPage(number);
        fetchData(number, pageSize, search, {
            linhVucId: filterLinhVuc,
            loaiYeuCauId: filterLoaiYeuCau,
            status: filterStatus,
            khoaId: filterKhoa,
            mucDoPhucTap: filterMucDoPhucTap,
            mucDoUuTien: filterMucDoUuTien,
            nguoiDungId: filterNguoiDung,
            nhanVienThucHienId: filterNhanVienThucHien,
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        }, true);
    };

    const onChangeShowNumber = (e) => {
        const newSize = parseInt(e.target.value);
        setPageSize(newSize);
        fetchData(page, newSize, search, {
            linhVucId: filterLinhVuc,
            loaiYeuCauId: filterLoaiYeuCau,
            status: filterStatus,
            khoaId: filterKhoa,
            mucDoPhucTap: filterMucDoPhucTap,
            mucDoUuTien: filterMucDoUuTien,
            nguoiDungId: filterNguoiDung,
            nhanVienThucHienId: filterNhanVienThucHien,
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        }, true);
    };

    // Apply / Reset filters
    const onApplyFilters = () => {
        const modelFilters = {
            linhVucId: filterLinhVuc,
            loaiYeuCauId: filterLoaiYeuCau,
            status: filterStatus,
            khoaId: filterKhoa,
            mucDoPhucTap: filterMucDoPhucTap,
            mucDoUuTien: filterMucDoUuTien,
            nguoiDungId: filterNguoiDung,
            nhanVienThucHienId: filterNhanVienThucHien,
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        };
        setPage(1);
        fetchData(1, pageSize, search, modelFilters, true);
    };

    const onResetFilters = () => {
        setFilterLinhVuc([]);
        setFilterLoaiYeuCau([]);
        setFilterStatus([]);
        setFilterKhoa([]);
        setFilterMucDoPhucTap([]);
        setFilterMucDoUuTien([]);
        setFilterNguoiDung([]);
        setSelectedNguoiDungOption(null);
        setFilterNhanVienThucHien([]);
        setDates({ startDate: null, endDate: null });
        setPage(1);
        fetchData(1, pageSize, search, {}, true);
    };

    const onShowMine = () => {
        const myId = myNguoiDungId;

        if (!myId) {
            toast.warn('Chưa lấy được NguoiDungId của tài khoản đăng nhập.');
            return;
        }

        setFilterNguoiDung([String(myId)]);
        setSelectedNguoiDungOption([{ value: String(myId), label: myNguoiDungName || 'Của tôi' }]);
        setSearchNguoiDung(myNguoiDungName || '');

        setPage(1);
        fetchData(1, pageSize, search, {
            linhVucId: filterLinhVuc,
            status: filterStatus,
            khoaId: filterKhoa,
            nguoiDungId: [String(myId)],
            nhanVienThucHienId: filterNhanVienThucHien,
            mucDoPhucTap: filterMucDoPhucTap,
            mucDoUuTien: filterMucDoUuTien,
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        }, true);
    };

    const onShowAll = () => {
        setFilterNguoiDung([]);
        setSelectedNguoiDungOption(null);
        setSearchNguoiDung('');

        setPage(1);
        fetchData(1, pageSize, search, {
            linhVucId: filterLinhVuc,
            status: filterStatus,
            khoaId: filterKhoa,
            nhanVienThucHienId: filterNhanVienThucHien,
            mucDoPhucTap: filterMucDoPhucTap,
            mucDoUuTien: filterMucDoUuTien,
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        }, true);
    };


    // ==========================
    // DELETE
    // ==========================
    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (!idWantDelete) return;

        try {
            // unwrap will throw if rejected
            await dispatch(deleteYeuCauAction(idWantDelete)).unwrap();

            await dispatch(filterListYeuCau(idWantDelete));
            toast.success(messageToast.messageToastDeleteSuccess);

            // compute new total records after deletion and adjust page
            const newTotal = Math.max(0, (totalYeuCau || 0) - 1);
            const maxPage = Math.max(1, Math.ceil(newTotal / pageSize));
            const targetPage = page > maxPage ? maxPage : page;

            if (targetPage !== page) setPage(targetPage);

            await fetchData(targetPage, pageSize, search, {
                linhVucId: filterLinhVuc,
                status: filterStatus,
                khoaId: filterKhoa,
                mucDoPhucTap: filterMucDoPhucTap,
                mucDoUuTien: filterMucDoUuTien,
                nguoiDungId: filterNguoiDung,
                nhanVienThucHienId: filterNhanVienThucHien,
                ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
                ngayTo: dates.endDate ? dates.endDate.toDate() : null
            }, true);
        } catch (err) {
            // try to show meaningful error
            const errMsg = err?.errors?.content?.[0] || err?.message || messageToast.messageToastTryCatch;
            toast.error(errMsg);
        }

        setOpenConfirmDeleteModal(false);
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    // ==========================
    // Người tạo autocomplete (react-select)
    // ==========================
    const [nguoiDungOptions, setNguoiDungOptions] = useState([]);
    const [searchNguoiDung, setSearchNguoiDung] = useState('');
    const nguoiDungTimeoutRef = useRef(null);
    const allNguoiDungCacheRef = useRef([]);

    const fetchNguoiDungOptions = async (keyword) => {
        try {
            const model = { Keyword: keyword || '', PageIndex: 1, PageSize: 20 };
            const res = await Get(NGUOIDUNG_API.GET_ALL, null, model);

            const findArray = (obj) => {
                if (!obj) return [];
                if (Array.isArray(obj)) return obj;
                if (typeof obj !== 'object') return [];
                for (const k of Object.keys(obj)) {
                    const v = obj[k];
                    if (Array.isArray(v)) return v;
                    if (v && typeof v === 'object') {
                        const nested = findArray(v);
                        if (nested && nested.length > 0) return nested;
                    }
                }
                return [];
            };

            const items = findArray(res) || [];
            const options = items.map(u => ({
                value: String(u.id || u.nguoiDungId || u.accountId || u.userId),
                label: u.hoTen || u.fullName || u.name || u.ten || u.displayName || String(u.id || u.nguoiDungId)
            }));

            allNguoiDungCacheRef.current = options;
            setNguoiDungOptions(options);
        } catch (err) {
            setNguoiDungOptions([]);
        }
    };

    const handleSelectNguoiDung = (opt) => {
        if (!opt || (Array.isArray(opt) && opt.length === 0)) {
            setSelectedNguoiDungOption(null);
            setFilterNguoiDung([]);
            setSearchNguoiDung('');
            return;
        }
        if (Array.isArray(opt)) {
            setSelectedNguoiDungOption(opt.map(o => ({ value: String(o.value), label: o.label })));
            setFilterNguoiDung(opt.map(o => String(o.value)));
            setSearchNguoiDung('');
        } else {
            setSelectedNguoiDungOption({ value: String(opt.value), label: opt.label });
            setFilterNguoiDung([String(opt.value)]);
            setSearchNguoiDung(opt.label || '');
        }
    };

    const handleNguoiDungSelectInputChange = (input, meta) => {
        // Chỉ xử lý khi người dùng gõ thật sự
        if (meta?.action !== 'input-change') return input;

        setSearchNguoiDung(input);

        // Nếu không có input -> ưu tiên đổ ngay từ cache (không để No options)
        if (!input) {
            if (allNguoiDungCacheRef.current.length > 0) {
                setNguoiDungOptions([...allNguoiDungCacheRef.current]); // clone để chắc chắn rerender
                return input;
            }
        }

        // Nếu có input và cache có dữ liệu -> filter local trước
        if (input && allNguoiDungCacheRef.current.length > 0) {
            const local = allNguoiDungCacheRef.current.filter(o =>
                (o.label || '').toLowerCase().includes(input.toLowerCase())
            );
            if (local.length > 0) {
                setNguoiDungOptions(local); // local là mảng mới, ok
                return input;
            }
        }

        // Debounce fetch
        if (nguoiDungTimeoutRef.current) clearTimeout(nguoiDungTimeoutRef.current);
        nguoiDungTimeoutRef.current = setTimeout(() => {
            fetchNguoiDungOptions(input || '');
        }, 250);

        return input;
    };

    const handleNguoiDungMenuOpen = () => {
        // Nếu đã cache rồi thì đổ ngay (tránh No options)
        if (allNguoiDungCacheRef.current.length > 0) {
            setNguoiDungOptions([...allNguoiDungCacheRef.current]);
            return;
        }

        // Chưa có cache -> fetch ngay danh sách (không debounce)
        fetchNguoiDungOptions('');
    };



    // date range handlers (used by DateRangePicker)
    const handleApply = (event, picker) => {
        setDates({ startDate: picker.startDate, endDate: picker.endDate });
        picker.element.val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`);
    };

    const handleCancel = (event, picker) => {
        setDates({ startDate: null, endDate: null });
        picker.element.val('');
    };

    const getTicketDisplay = (url) => {
        if (!url) return '';
        // Bắt đúng dạng GitHub issue
        const match = url.match(/github\.com\/.+\/issues\/(\d+)/);
        // Nếu đúng → trả về số ticket
        if (match) return match[1];
        // Nếu không đúng → hiển thị chữ "Link"
        return 'Link';
    };

    // kiểm tra yêu cầu đã hoàn thành hay chưa
    const isHoanThanhYeuCau = (status) => {
        return status === 4 || String(status).toLowerCase() === 'hoanthanh';
    };

    // ==========================
    // RENDER
    // ==========================
    return (
        <>
            <style>
                {`
                    @media (min-width: 992px) {
                        .yeucau-detail-modal-dialog {
                            max-width: min(1200px, calc(100vw - var(--yeucau-detail-sidebar-width) - 32px));
                            margin-left: calc(var(--yeucau-detail-sidebar-width) / 2 + 16px);
                            margin-right: 16px;
                        }
                    }

                    @media (max-width: 991.98px) {
                        .yeucau-detail-modal-dialog {
                            max-width: calc(100vw - 32px);
                            margin-left: 16px;
                            margin-right: 16px;
                        }
                    }

                    /* Dòng hoàn thành: dùng 1 màu thống nhất, không bị striped / hover làm lệch */
                    .table > tbody > tr.yeucau-row-hoanthanh > * {
                        background-color: #dff3df !important;
                        --bs-table-accent-bg: #dff3df !important;
                        box-shadow: inset 0 0 0 9999px #dff3df !important;
                    }

                    .table-hover > tbody > tr.yeucau-row-hoanthanh:hover > * {
                        background-color: #dff3df !important;
                        --bs-table-accent-bg: #dff3df !important;
                        box-shadow: inset 0 0 0 9999px #dff3df !important;
                    }
                `}
            </style>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">Danh sách Yêu cầu</h3>
                            </div>

                            <div className="card-body">
                                <div className="d-flex justify-content-between mb-2">
                                    <form className="form-inline">
                                        <label className="mr-2">Hiển thị :</label>
                                        <select className="form-control" value={pageSize} onChange={onChangeShowNumber}>
                                            {objectShowNumber.map((item, key) => (
                                                <option key={key} value={item.value}>{item.text}</option>
                                            ))}
                                        </select>
                                    </form>

                                    <div className="d-flex align-items-center">
                                        <div className="btn-group btn-group-sm mr-2">
                                            <button
                                                type="button"
                                                className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={onShowList}
                                            >
                                                Danh sách
                                            </button>
                                            <button
                                                type="button"
                                                className={`btn ${viewMode === 'summary' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={onShowSummary}
                                            >
                                                Thống kê
                                            </button>
                                        </div>

                                        <NavLink className="nav-link-reject nav-link" to={URI_INTERNAL.YEUCAU_CREATE_PATH}>
                                            <button type="button" className="btn btn-info btn-sm">Thêm mới</button>
                                        </NavLink>
                                    </div>
                                </div>

                                {/* Filters UI */}
                                {viewMode === 'list' && (
                                    <>
                                        <div className="mb-2">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <div className="d-flex align-items-center flex-wrap">
                                                    {/* QUICK SEARCH: gõ tới đâu lọc tới đó */}
                                                    <div className="d-flex align-items-center mr-2" style={{ minWidth: 260 }}>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Tìm theo nội dung..."
                                                            value={search}
                                                            onChange={handleQuickSearchChange}
                                                            onKeyDown={(ev) => {
                                                                // tránh Enter submit form (nếu nằm trong form nào đó)
                                                                if (ev.key === 'Enter') ev.preventDefault();
                                                            }}
                                                            style={{ width: 260 }}
                                                        />
                                                        {search ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-light ml-1"
                                                                title="Xóa tìm kiếm"
                                                                onClick={clearQuickSearch}
                                                            >
                                                                ×
                                                            </button>
                                                        ) : null}
                                                    </div>

                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-primary mr-2"
                                                        onClick={() => setShowAdvancedFilters(true)}
                                                    >
                                                        Lọc nâng cao
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm mr-2 ${myNguoiDungId && filterNguoiDung && filterNguoiDung.includes(String(myNguoiDungId))
                                                            ? 'btn-primary'
                                                            : 'btn-outline-primary'
                                                            }`}
                                                        onClick={onShowMine}
                                                    >
                                                        Của tôi
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm mr-2 ${(!filterNguoiDung || filterNguoiDung.length === 0) ? 'btn-primary' : 'btn-outline-primary'}`}
                                                        onClick={onShowAll}
                                                    >
                                                        Tất cả
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-light ml-2"
                                                        title="Xóa lọc"
                                                        onClick={() => { onResetFilters(); }}
                                                    >
                                                        Xóa lọc
                                                    </button>
                                                </div>

                                            </div>

                                        </div>

                                        {showAdvancedFilters && (
                                            <>
                                                <div className="modal show" style={{ display: 'block', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2000 }} tabIndex="-1" role="dialog">
                                                    <div className="modal-dialog modal-lg" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title">Lọc nâng cao</h5>
                                                                <button type="button" className="close" onClick={() => setShowAdvancedFilters(false)} aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <div className="container-fluid p-0">
                                                                    <div className="row">

                                                                        {/* Lĩnh vực */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-start">
                                                                                <label className="mb-0 mr-2 font-weight-bold" style={{ width: 150, paddingTop: '4px', whiteSpace: 'nowrap' }}>
                                                                                    Lĩnh vực:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={linhVucOptions}
                                                                                        value={filterLinhVuc && filterLinhVuc.length ? linhVucOptions.filter(o => filterLinhVuc.includes(String(o.value))) : null}
                                                                                        onChange={(opts) => setFilterLinhVuc((opts || []).map(o => String(o.value)))}
                                                                                        isMulti
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Loại yêu cầu (multi) */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-start">
                                                                                <label className="mb-0 mr-2 font-weight-bold" style={{ width: 150, paddingTop: '4px', whiteSpace: 'nowrap' }}>
                                                                                    Loại yêu cầu:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={loaiYeuCauOptions}
                                                                                        value={filterLoaiYeuCau && filterLoaiYeuCau.length ? loaiYeuCauOptions.filter(o => filterLoaiYeuCau.includes(String(o.value))) : null}
                                                                                        onChange={(opts) => setFilterLoaiYeuCau((opts || []).map(o => String(o.value)))}
                                                                                        isMulti
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Trạng thái (multi) */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-start">
                                                                                <label className="mb-0 mr-2 font-weight-bold" style={{ width: 150, paddingTop: '4px', whiteSpace: 'nowrap' }}>
                                                                                    Trạng thái:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={trangThaiOptions}
                                                                                        value={filterStatus && filterStatus.length ? trangThaiOptions.filter(o => filterStatus.includes(String(o.value)) || filterStatus.includes(o.value)) : null}
                                                                                        onChange={(opts) => setFilterStatus((opts || []).map(o => o.value))}
                                                                                        isMulti
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Mức độ phức tạp (multi) */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-start">
                                                                                <label className="mb-0 mr-2 font-weight-bold" style={{ width: 150, paddingTop: '4px', whiteSpace: 'nowrap' }}>
                                                                                    Mức độ phức tạp:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={mucDoPhucTapOptions}
                                                                                        value={filterMucDoPhucTap && filterMucDoPhucTap.length ? mucDoPhucTapOptions.filter(o => filterMucDoPhucTap.includes(String(o.value))) : null}
                                                                                        onChange={(opts) => setFilterMucDoPhucTap((opts || []).map(o => String(o.value)))}
                                                                                        isMulti
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Mức độ ưu tiên (multi) */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-start">
                                                                                <label className="mb-0 mr-2 font-weight-bold" style={{ width: 150, paddingTop: '4px', whiteSpace: 'nowrap' }}>
                                                                                    Mức độ ưu tiên:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={mucDoUuTienOptions}
                                                                                        value={filterMucDoUuTien && filterMucDoUuTien.length ? mucDoUuTienOptions.filter(o => filterMucDoUuTien.includes(String(o.value))) : null}
                                                                                        onChange={(opts) => setFilterMucDoUuTien((opts || []).map(o => String(o.value)))}
                                                                                        isMulti
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Khoa (multi) */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-start">
                                                                                <label className="mb-0 mr-2 font-weight-bold" style={{ width: 150, paddingTop: '4px', whiteSpace: 'nowrap' }}>
                                                                                    Khoa:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={khoaOptions}
                                                                                        value={filterKhoa && filterKhoa.length ? khoaOptions.filter(o => filterKhoa.includes(String(o.value))) : null}
                                                                                        onChange={(opts) => setFilterKhoa((opts || []).map(o => String(o.value)))}
                                                                                        isMulti
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Người tạo (multi autocomplete) */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-start">
                                                                                <label className="mb-0 mr-2 font-weight-bold" style={{ width: 150, paddingTop: '4px', whiteSpace: 'nowrap' }}>
                                                                                    Người tạo:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={nguoiDungOptions}
                                                                                        value={selectedNguoiDungOption && selectedNguoiDungOption.length ? selectedNguoiDungOption.map(o => ({ value: o.value, label: o.label })) : null}
                                                                                        onChange={(opt) => handleSelectNguoiDung(opt)}
                                                                                        onInputChange={handleNguoiDungSelectInputChange}
                                                                                        onMenuOpen={handleNguoiDungMenuOpen}
                                                                                        isMulti
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Nhân viên thực hiện (multi) */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-start">
                                                                                <label className="mb-0 mr-2 font-weight-bold" style={{ width: 150, paddingTop: '4px', whiteSpace: 'nowrap' }}>
                                                                                    NV thực hiện:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={nhanVienThucHienOptions}
                                                                                        value={filterNhanVienThucHien && filterNhanVienThucHien.length ? nhanVienThucHienOptions.filter(o => filterNhanVienThucHien.includes(String(o.value))) : null}
                                                                                        onChange={(opts) => setFilterNhanVienThucHien((opts || []).map(o => String(o.value)))}
                                                                                        isMulti
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Thời gian */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-start">
                                                                                <label className="mb-0 mr-2 font-weight-bold" style={{ width: 150, paddingTop: '4px', whiteSpace: 'nowrap' }}>
                                                                                    Thời gian:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <DateRangePicker
                                                                                        onApply={(event, picker) => {
                                                                                            setDates({ startDate: picker.startDate, endDate: picker.endDate });
                                                                                            picker.element.val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`);
                                                                                        }}
                                                                                        onCancel={(event, picker) => {
                                                                                            setDates({ startDate: null, endDate: null });
                                                                                            picker.element.val('');
                                                                                        }}
                                                                                        initialSettings={{
                                                                                            autoUpdateInput: false,
                                                                                            locale: { format: 'DD/MM/YYYY', cancelLabel: 'Xóa', applyLabel: 'Chọn' },
                                                                                            linkedCalendars: false,
                                                                                            showDropdowns: true
                                                                                        }}
                                                                                    >
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control form-control-sm"
                                                                                            style={{ width: '100%' }}
                                                                                            defaultValue={dates.startDate && dates.endDate ? `${dates.startDate.format('DD/MM/YYYY')} - ${dates.endDate.format('DD/MM/YYYY')}` : ''}
                                                                                            onChange={(e) => { if (e.target.value.length === 0) setDates({ startDate: null, endDate: null }); }}
                                                                                        />
                                                                                    </DateRangePicker>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-primary btn-sm mr-2" onClick={() => { onApplyFilters(); setShowAdvancedFilters(false); }}>Áp dụng</button>
                                                                <button type="button" className="btn btn-secondary btn-sm" onClick={() => { onResetFilters(); setShowAdvancedFilters(false); }}>Xóa lọc</button>
                                                                <button type="button" className="btn btn-light btn-sm" onClick={() => setShowAdvancedFilters(false)}>Đóng</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        <div className="position-relative">
                                            {listLoading && (
                                                <div
                                                    className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                                                    style={{ top: 0, left: 0, background: 'rgba(255,255,255,0.65)', zIndex: 10 }}
                                                >
                                                    <Spinner animation="border" />
                                                </div>
                                            )}
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: 50 }}>STT</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Người tạo yêu cầu</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Lĩnh vực</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Loại yêu cầu</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Khoa hỗ trợ</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ngày bắt đầu</th>
                                                        <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: '35%' }}>Nội dung</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Link Ticket</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Trạng thái</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tệp</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Chức năng</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {listYeuCau && listYeuCau.length > 0 ? (
                                                        (() => {
                                                            const urlParams = new URLSearchParams(location.search);
                                                            const hasAppliedStatus = urlParams.has('status');

                                                            // Chỉ gom nhóm khi có filter status trong URL (đã ấn Áp dụng)
                                                            if (hasAppliedStatus) {
                                                                const sortedList = [...listYeuCau].sort((a, b) => String(a.status).localeCompare(String(b.status)));
                                                                const groups = [];
                                                                let currentStatus = null;
                                                                let currentGroup = [];

                                                                sortedList.forEach((item) => {
                                                                    const status = String(item.status);
                                                                    if (status !== currentStatus) {
                                                                        if (currentGroup.length > 0) {
                                                                            groups.push({ status: currentStatus, items: currentGroup });
                                                                        }
                                                                        currentStatus = status;
                                                                        currentGroup = [item];
                                                                    } else {
                                                                        currentGroup.push(item);
                                                                    }
                                                                });
                                                                if (currentGroup.length > 0) {
                                                                    groups.push({ status: currentStatus, items: currentGroup });
                                                                }

                                                                return groups.map((group, gIdx) => (
                                                                    <React.Fragment key={`group-${group.status}`}>
                                                                        <tr className="bg-light">
                                                                            <td colSpan="11" className="font-weight-bold" style={{ backgroundColor: '#f4f6f9' }}>
                                                                                <i className="fas fa-layer-group mr-2"></i>
                                                                                Trạng thái: {(() => {
                                                                                    const s = group.status;
                                                                                    // Chuyển về Number nếu là chuỗi số, nếu không giữ nguyên (cho key như 'hoanthanh')
                                                                                    const val = (s !== '' && s !== 'null' && s !== 'undefined' && !isNaN(Number(s))) ? Number(s) : s;
                                                                                    const lbl = mapTrangThaiYeuCauLabel(val);

                                                                                    if (lbl === null || lbl === undefined || lbl === 'null' || lbl === 'undefined') {
                                                                                        return 'Không xác định';
                                                                                    }
                                                                                    return lbl;
                                                                                })()} ({group.items.length})
                                                                            </td>
                                                                        </tr>
                                                                        {group.items.map((item, index) => (
                                                                            <tr
                                                                                key={item.id}
                                                                                className={isHoanThanhYeuCau(item.status) ? 'yeucau-row-hoanthanh' : ''}
                                                                            >
                                                                                <td>{index + 1 + (page - 1) * pageSize}</td>
                                                                                <td>
                                                                                    {(() => {
                                                                                        const id = item?.nguoiDungId ? String(item.nguoiDungId) : '';
                                                                                        const name = id ? userNameMap[id] : '';

                                                                                        if (name) return <span>{name}</span>;
                                                                                        if (id && loadingUserIds[id]) return <span className="text-muted">Đang tải...</span>;

                                                                                        return <span className="text-muted">—</span>;
                                                                                    })()}
                                                                                </td>

                                                                                <td>{getTenLinhVuc(item.linhVucId)}</td>
                                                                                <td>{item.loaiYeuCauId ? getTenLoaiYeuCau(item.loaiYeuCauId) : ''}</td>
                                                                                <td>{getTenKhoa(item.khoaIds)}</td>
                                                                                <td>{item.ngayBatDau ? new Date(item.ngayBatDau).toLocaleDateString() : ''}</td>
                                                                                <td style={{ width: '35%', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                                                    <div
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={() => openDetailModal(item.id)}
                                                                                    >
                                                                                        {item.noiDung}
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    {item.linkTicket ? (
                                                                                        <a href={item.linkTicket} target="_blank" rel="noopener noreferrer">
                                                                                            {getTicketDisplay(item.linkTicket)}
                                                                                        </a>
                                                                                    ) : ''}
                                                                                </td>
                                                                                <td>
                                                                                    {mapTrangThaiYeuCauLabel(item.status)}
                                                                                </td>
                                                                                <td>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <button
                                                                                            className="btn btn-sm btn-link p-0 mr-1"
                                                                                            onClick={() => openFilesModal(item.id)}
                                                                                            title="Xem tệp đính kèm"
                                                                                        >
                                                                                            Tệp
                                                                                        </button>
                                                                                        {filesByYeuCau[item.id] && filesByYeuCau[item.id].length > 0 && (
                                                                                            <small className="text-muted">({filesByYeuCau[item.id].length})</small>
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                                                                    <Dropdown align="end">
                                                                                        <Dropdown.Toggle variant="outline-secondary" size="sm" id={`yeucau-actions-${item.id}`}>
                                                                                            Thao tác
                                                                                        </Dropdown.Toggle>
                                                                                        <Dropdown.Menu>
                                                                                            <Dropdown.Item
                                                                                                as={NavLink}
                                                                                                to={createUrlWithParam(URI_INTERNAL.YEUCAU_EDIT_PATH, { id: item.id })}
                                                                                            >
                                                                                                Sửa
                                                                                            </Dropdown.Item>

                                                                                            <Dropdown.Item
                                                                                                as="button"
                                                                                                className="w-100 text-left"
                                                                                                onClick={() => openDetailModal(item.id)}
                                                                                            >
                                                                                                Xem chi tiết
                                                                                            </Dropdown.Item>

                                                                                            <Dropdown.Divider />
                                                                                            <Dropdown.Item
                                                                                                as="button"
                                                                                                className="w-100 text-left text-danger"
                                                                                                onClick={() => deleteAction(item.id, item.noiDung)}
                                                                                            >
                                                                                                Xóa
                                                                                            </Dropdown.Item>
                                                                                        </Dropdown.Menu>
                                                                                    </Dropdown>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </React.Fragment>
                                                                ));
                                                            }

                                                            // Nếu không gom nhóm (không filter status) -> hiển thị list bình thường
                                                            return listYeuCau.map((item, index) => (
                                                                <tr
                                                                    key={item.id}
                                                                    className={isHoanThanhYeuCau(item.status) ? 'yeucau-row-hoanthanh' : ''}
                                                                >
                                                                    <td>{index + 1 + (page - 1) * pageSize}</td>
                                                                    <td>
                                                                        {(() => {
                                                                            const id = item?.nguoiDungId ? String(item.nguoiDungId) : '';
                                                                            const name = id ? userNameMap[id] : '';

                                                                            if (name) return <span>{name}</span>;
                                                                            if (id && loadingUserIds[id]) return <span className="text-muted">Đang tải...</span>;

                                                                            return <span className="text-muted">—</span>;
                                                                        })()}
                                                                    </td>

                                                                    <td>{getTenLinhVuc(item.linhVucId)}</td>
                                                                    <td>{item.loaiYeuCauId ? getTenLoaiYeuCau(item.loaiYeuCauId) : ''}</td>
                                                                    <td>{getTenKhoa(item.khoaIds)}</td>
                                                                    <td>{item.ngayBatDau ? new Date(item.ngayBatDau).toLocaleDateString() : ''}</td>
                                                                    <td style={{ width: '35%', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                                        <div
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => openDetailModal(item.id)}
                                                                        >
                                                                            {item.noiDung}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        {item.linkTicket && (
                                                                            <a href={item.linkTicket} target="_blank" rel="noopener noreferrer" title={item.linkTicket}>
                                                                                {getTicketDisplay(item.linkTicket)}
                                                                            </a>
                                                                        )}
                                                                    </td>
                                                                    <td>{mapTrangThaiYeuCauLabel(item.status)}</td>
                                                                    <td>
                                                                        {(() => {
                                                                            const files = Array.isArray(filesByYeuCau[item.id]) ? filesByYeuCau[item.id] : null;

                                                                            if (files === null) return <span className="text-muted">...</span>;

                                                                            const count = files.length;

                                                                            if (count === 0) {
                                                                                return <span className="text-muted"></span>;
                                                                            }

                                                                            return (
                                                                                <button className="btn btn-sm btn-link" onClick={() => openFilesModal(item.id)}>
                                                                                    Tệp ({count})
                                                                                </button>
                                                                            );
                                                                        })()}
                                                                    </td>



                                                                    <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                                                        <Dropdown align="end">
                                                                            <Dropdown.Toggle variant="outline-secondary" size="sm" id={`yeucau-actions-${item.id}`}>
                                                                                Thao tác
                                                                            </Dropdown.Toggle>

                                                                            <Dropdown.Menu>
                                                                                <Dropdown.Item
                                                                                    as={NavLink}
                                                                                    to={createUrlWithParam(URI_INTERNAL.YEUCAU_EDIT_PATH, { id: item.id })}
                                                                                >
                                                                                    Sửa
                                                                                </Dropdown.Item>

                                                                                <Dropdown.Item
                                                                                    as="button"
                                                                                    className="w-100 text-left"
                                                                                    onClick={() => openDetailModal(item.id)}
                                                                                >
                                                                                    Xem chi tiết
                                                                                </Dropdown.Item>

                                                                                <Dropdown.Divider />
                                                                                <Dropdown.Item
                                                                                    as="button"
                                                                                    className="w-100 text-left text-danger"
                                                                                    onClick={() => deleteAction(item.id, item.noiDung)}
                                                                                >
                                                                                    Xóa
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>

                                                                </tr>
                                                            ));
                                                        })()
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="11" className="text-center">Không có dữ liệu</td>
                                                        </tr>
                                                    )}
                                                </tbody>

                                                <tfoot>
                                                    <tr>
                                                        <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: 50 }}>STT</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Người tạo yêu cầu</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Lĩnh vực</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Loại yêu cầu</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Khoa hỗ trợ</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ngày bắt đầu</th>
                                                        <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: '35%' }}>Nội dung</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Link Ticket</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Trạng thái</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tệp</th>
                                                        <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Chức năng</th>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </div>


                                        <div className="dataTables_paginate paging_simple_numbers">
                                            <Pagination
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                innerClass={"pagination pagination-sm no-margin pull-right"}
                                                activePage={page}
                                                itemsCountPerPage={Number(pageSize)}
                                                totalItemsCount={totalYeuCau}
                                                pageRangeDisplayed={5}
                                                onChange={changePage}
                                            />
                                        </div>
                                    </>
                                )}

                                {viewMode === 'summary' && (
                                    <div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <StatisticControls
                                                dates={dates}
                                                setDates={setDates}
                                                groupBy={groupBy}
                                                setGroupBy={setGroupBy}
                                                onReload={onShowSummary}
                                                onBack={onShowList}
                                                ranges={rangeDateReport}
                                            />
                                        </div>

                                        {thongKeState.loading ? (
                                            <div className="text-center my-3"><Spinner animation="border" /></div>
                                        ) : yeuCauSummaryList && yeuCauSummaryList.length > 0 ? (
                                            <>
                                                <div className="mb-2">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Tìm người..."
                                                        value={summarySearch}
                                                        onChange={(e) => setSummarySearch(e.target.value)}
                                                        style={{ maxWidth: 320 }}
                                                    />
                                                </div>

                                                <Table striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: 30 }}>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={toggleSelectAll}
                                                                    checked={filteredSummary.length > 0 && filteredSummary.every(i => selectedSummaryIds.includes(String(i.nguoiDungId || i.nguoiDung || '')))}
                                                                />
                                                            </th>
                                                            <th>STT</th>
                                                            <th>Người</th>
                                                            <th>Tổng số yêu cầu</th>
                                                            {TRANG_THAI_YEU_CAU_OPTIONS.map(s => (
                                                                <th key={s.key} className="text-center">{s.label}</th>
                                                            ))}
                                                            <th>Chi tiết</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {filteredSummary.map((item, index) => {
                                                            const idKey = String(item.nguoiDungId || item.nguoiDung || '');
                                                            const checked = selectedSummaryIds.includes(idKey);
                                                            // compute total either from provided Count or sum of status counts
                                                            const totalFromCount = item.count ?? item.Content ?? item.total ?? item.Total;
                                                            const statusVals = TRANG_THAI_YEU_CAU_OPTIONS.map(s => getStatusCount(item, s.key));
                                                            const total = totalFromCount !== undefined && totalFromCount !== null ? totalFromCount : statusVals.reduce((a, b) => a + b, 0);
                                                            return (
                                                                <tr key={idKey || index}>
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={checked}
                                                                            onChange={() => toggleSelect(idKey)}
                                                                        />
                                                                    </td>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.tenNguoiDung || item.ten || item.nguoiDungName || item.nguoiDungId}</td>
                                                                    <td className="text-center">{total}</td>
                                                                    {TRANG_THAI_YEU_CAU_OPTIONS.map((s, idx) => (
                                                                        <td key={s.key} className="text-center">{statusVals[idx] ?? 0}</td>
                                                                    ))}
                                                                    <td>
                                                                        <button
                                                                            className="btn btn-sm btn-info"
                                                                            onClick={() => onShowBreakdownForUser(item.nguoiDungId || item.nguoiDung)}
                                                                        >
                                                                            Xem chi tiết
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>

                                                    {selectedSummaryIds && selectedSummaryIds.length > 0 && (() => {
                                                        const setSel = new Set(selectedSummaryIds);
                                                        const rows = (yeuCauSummaryList || []).filter(r => setSel.has(String(r.nguoiDungId || r.nguoiDung || '')));
                                                        const sumTotals = rows.reduce((acc, r) => {
                                                            const totalFromCount = r.count ?? r.Content ?? r.total ?? r.Total;
                                                            if (totalFromCount !== undefined && totalFromCount !== null) return acc + totalFromCount;
                                                            // sum statuses
                                                            const ssum = TRANG_THAI_YEU_CAU_OPTIONS.reduce((s, opt) => s + getStatusCount(r, opt.key), 0);
                                                            return acc + ssum;
                                                        }, 0);
                                                        const sumByStatus = TRANG_THAI_YEU_CAU_OPTIONS.map(opt => rows.reduce((s, r) => s + getStatusCount(r, opt.key), 0));
                                                        return (
                                                            <tfoot>
                                                                <tr className="font-weight-bold">
                                                                    <td />
                                                                    <td colSpan={2}>Tổng chọn</td>
                                                                    <td className="text-center">{sumTotals}</td>
                                                                    {sumByStatus.map((v, i) => (
                                                                        <td key={i} className="text-center">{v}</td>
                                                                    ))}
                                                                    <td />
                                                                </tr>
                                                            </tfoot>
                                                        );
                                                    })()}
                                                </Table>

                                                <div className="text-center my-3">
                                                    <Pagination
                                                        itemClass="page-item"
                                                        linkClass="page-link"
                                                        innerClass={"pagination pagination-sm no-margin pull-right"}
                                                        activePage={page}
                                                        itemsCountPerPage={Number(pageSize)}
                                                        totalItemsCount={totalYeuCau}
                                                        pageRangeDisplayed={5}
                                                        onChange={changePage}
                                                    />
                                                </div>
                                            </>
                                        ) : (
                                            <div className="text-center">Không có dữ liệu</div>
                                        )}
                                    </div>
                                )}

                                {viewMode === 'breakdown' && (
                                    <div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div>
                                                <button className="btn btn-sm btn-secondary mr-2" onClick={onShowSummary}>Quay lại Thống kê</button>
                                                {/*<strong>Group by: {groupBy}</strong>*/}
                                            </div>
                                            <div>
                                                <button className="btn btn-sm btn-primary" onClick={() => dispatch(getYeuCauBreakdownAction({
                                                    from: dates.startDate ? dates.startDate.format('YYYY-MM-DD') : null,
                                                    to: dates.endDate ? dates.endDate.format('YYYY-MM-DD') : null,
                                                    groupBy: groupBy,
                                                    nguoiDungId: selectedUserForBreakdown
                                                }))}>Tải lại</button>
                                            </div>
                                        </div>

                                        {thongKeState.loading ? (
                                            <div className="text-center my-3"><Spinner animation="border" /></div>
                                        ) : yeuCauBreakdownList && yeuCauBreakdownList.length > 0 ? (
                                            <>
                                                {(() => {
                                                    const rows = yeuCauBreakdownList || [];
                                                    const sumByStatus = TRANG_THAI_YEU_CAU_OPTIONS.map(opt => rows.reduce((s, r) => s + getStatusCount(r, opt.key), 0));
                                                    const grandTotal = sumByStatus.reduce((a, b) => a + b, 0);
                                                    return (
                                                        <div className="mb-2 small text-muted">Tổng: {TRANG_THAI_YEU_CAU_OPTIONS.map((opt, i) => `${opt.label}: ${sumByStatus[i]}`).join(' — ')} — Tổng: <strong>{grandTotal}</strong></div>
                                                    );
                                                })()}

                                                <Table striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            <th>STT</th>
                                                            <th>Thời gian</th>
                                                            {TRANG_THAI_YEU_CAU_OPTIONS.map(s => (
                                                                <th key={s.key} className="text-center">{s.label}</th>
                                                            ))}
                                                            <th>Tổng</th>
                                                            <th>Hành động</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {yeuCauBreakdownList.map((item, index) => {
                                                            const raw = item.period || item.date || item.key || '';
                                                            let display = raw;
                                                            try {
                                                                if (raw && (moment(raw, moment.ISO_8601, true).isValid() || /^\d{4}-\d{2}-\d{2}/.test(raw))) {
                                                                    display = moment(raw).format('DD/MM/YYYY');
                                                                }
                                                            } catch (e) { }
                                                            const statusVals = TRANG_THAI_YEU_CAU_OPTIONS.map(s => getStatusCount(item, s.key));
                                                            const totalFromCount = item.count ?? item.Content ?? item.total ?? item.Total;
                                                            const total = totalFromCount !== undefined && totalFromCount !== null ? totalFromCount : statusVals.reduce((a, b) => a + b, 0);
                                                            const ids = item.yeuCauIds ?? item.YeuCauIds ?? null;

                                                            return (
                                                                <tr key={`${raw}-${index}`}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{display}</td>
                                                                    {statusVals.map((v, i) => (<td key={i} className="text-center">{v}</td>))}
                                                                    <td className="text-center">{total}</td>
                                                                    <td>
                                                                        {Array.isArray(ids) && ids.length > 0 ? (
                                                                            <>
                                                                                <button className="btn btn-sm btn-link" onClick={() => history.push(createUrlWithParam(URI_INTERNAL.YEUCAU_EDIT_PATH, { id: ids[0] }))}>Mở</button>
                                                                                <span className="small text-muted"> ({ids.length})</span>
                                                                            </>
                                                                        ) : (
                                                                            <button className="btn btn-sm btn-outline-primary" onClick={() => goToFilteredList(selectedUserForBreakdown, item.period, item.period)}>Xem</button>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </>
                                        ) : (
                                            <div className="text-center">Không có dữ liệu</div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <ConfirmModal
                    isOpen={openConfirmDeleteModal}
                    confirmType="delete"
                    handleAccept={acceptDelete}
                    handleCancel={cancelDelete}
                    content={confirmDelMessage}
                />

                <Modal show={filesModalOpen} onHide={closeFilesModal} size="md" backdrop={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Danh sách tệp</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {loadingFiles ? (
                            <div className="text-center"><Spinner animation="border" /></div>
                        ) : (
                            <ul className="list-unstyled">
                                {(filesByYeuCau[filesModalYeuCauId] || []).length === 0 ? (
                                    <li>Không có tệp đính kèm.</li>
                                ) : (
                                    (filesByYeuCau[filesModalYeuCauId] || []).map(f => {
                                        const url = makeFileUrl(f.fileUrl || f.fileurl || f.filePath || f.filePathUrl || f.fileUrlPath || f.file || f.FileUrl || '');
                                        const displayName = f.name || f.fileName || f.nameFile || f.FileName || 'Tệp đính kèm';
                                        const inline = canInlinePreview(f);
                                        return (
                                            <li key={f.id} className="d-flex align-items-center mb-2">
                                                {inline ? (
                                                    <a href={url} target="_blank" rel="noopener noreferrer">{displayName}</a>
                                                ) : (
                                                    <button type="button" className="btn btn-link p-0" onClick={() => handleDownloadYeuCauFile(f)}>{displayName}</button>
                                                )}

                                                <button type="button" className="btn btn-link ml-2 text-muted p-0" title={`Tải ${displayName}`} onClick={() => handleDownloadYeuCauFile(f)}>
                                                    <i className="fas fa-download" />
                                                </button>

                                                <small className="text-muted ml-2">{f.size ? `(${Math.round((f.size || 0) / 1024)} KB)` : ''}</small>
                                            </li>
                                        );
                                    })
                                )}
                            </ul>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={closeFilesModal}>Đóng</button>
                    </Modal.Footer>
                </Modal>

                {/* Detail modal (inline view) mới thêm 18/12 mở modal chi tiết */}
                <Modal
                    show={detailModalOpen}
                    onHide={closeDetailModal}
                    centered
                    backdrop={false}
                    style={{ zIndex: 10050 }}
                    dialogClassName="yeucau-detail-modal-dialog"
                >
                    <Modal.Header closeButton className="py-2">
                        <div className="d-flex flex-column">
                            <Modal.Title className="mb-0">Chi tiết Yêu cầu</Modal.Title>
                        </div>
                    </Modal.Header>

                    <Modal.Body
                        style={{
                            maxHeight: '70vh',
                            overflowY: 'auto',
                            overflowX: 'hidden'
                        }}>
                        {detailModalLoading ? (
                            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 160 }}>
                                <Spinner animation="border" />
                            </div>
                        ) : !detailModalItem ? (
                            <div>Không có dữ liệu</div>
                        ) : (
                            <div className="p-1">
                                {/* ====== GRID: Thông tin chung / Thời gian ====== */}
                                <div className="mb-3">
                                    <div className="text-uppercase text-muted small mb-2">Thông tin</div>

                                    <div className="row">
                                        {/* Cột trái: thu nhỏ */}
                                        <div className="col-lg-4 mb-3">
                                            <div className="border rounded p-3 h-100">
                                                {/* Người tạo / Lĩnh vực / Loại yêu cầu */}
                                                <div className="mb-2">
                                                    <div className="d-flex align-items-start mb-2">
                                                        <div
                                                            className="text-muted small"
                                                            style={{ width: 110, flex: '0 0 110px' }}
                                                        >
                                                            Người tạo:
                                                        </div>
                                                        <div className="font-weight-bold" style={{ flex: 1, minWidth: 0 }}>
                                                            {userNameMap[detailModalItem.nguoiDungId] ||
                                                                detailModalItem.nguoiDungName ||
                                                                detailModalItem.nguoiDung ||
                                                                detailModalItem.nguoiDungId}
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-start mb-2">
                                                        <div
                                                            className="text-muted small"
                                                            style={{ width: 110, flex: '0 0 110px' }}
                                                        >
                                                            Lĩnh vực:
                                                        </div>
                                                        <div className="font-weight-bold" style={{ flex: 1, minWidth: 0 }}>
                                                            {getTenLinhVuc(detailModalItem.linhVucId)}
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-start mb-0">
                                                        <div
                                                            className="text-muted small"
                                                            style={{ width: 110, flex: '0 0 110px' }}
                                                        >
                                                            Loại yêu cầu:
                                                        </div>
                                                        <div
                                                            className="font-weight-bold"
                                                            style={{
                                                                flex: 1,
                                                                minWidth: 0,
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word'
                                                            }}
                                                        >
                                                            {detailModalItem.loaiYeuCauId
                                                                ? getTenLoaiYeuCau(detailModalItem.loaiYeuCauId)
                                                                : <span className="text-muted">—</span>}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mb-2">
                                                    <div className="text-muted small">Khoa hỗ trợ</div>
                                                    <div className="font-weight-bold" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                        {getTenKhoa(detailModalItem.khoaIds)}
                                                    </div>
                                                </div>

                                                <div className="mb-0">
                                                    <div className="text-muted small">Link Ticket</div>
                                                    <div>
                                                        {detailModalItem.linkTicket ? (
                                                            <a
                                                                href={detailModalItem.linkTicket}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {getTicketDisplay(detailModalItem.linkTicket)}
                                                            </a>
                                                        ) : (
                                                            <span className="text-muted"></span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Cột phải: rộng hơn */}
                                        <div className="col-lg-8 mb-3">
                                            <div className="border rounded p-3 h-100">
                                                {/* HÀNG 1: 3 mốc thời gian trên 1 hàng */}
                                                <div className="row">
                                                    <div className="col-12 col-md-4 mb-2">
                                                        <div className="text-muted small">Ngày bắt đầu</div>
                                                        <div>
                                                            {detailModalItem.ngayBatDau
                                                                ? new Date(detailModalItem.ngayBatDau).toLocaleDateString()
                                                                : <span className="text-muted">—</span>}
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-4 mb-2">
                                                        <div className="text-muted small">Dự kiến hoàn thành</div>
                                                        <div>
                                                            {detailModalItem.ngayHoanThanhDuKien
                                                                ? new Date(detailModalItem.ngayHoanThanhDuKien).toLocaleDateString()
                                                                : <span className="text-muted"></span>}
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-4 mb-2">
                                                        <div className="text-muted small">Thực tế hoàn thành</div>
                                                        <div>
                                                            {detailModalItem.ngayHoanThanhThucTe
                                                                ? new Date(detailModalItem.ngayHoanThanhThucTe).toLocaleDateString()
                                                                : <span className="text-muted"></span>}
                                                        </div>
                                                    </div>
                                                </div>

                                                <hr className="my-2" />

                                                {/* HÀNG 2: trạng thái / ưu tiên / phức tạp trên 1 hàng */}
                                                <div className="row">
                                                    <div className="col-12 col-md-4 mb-0">
                                                        <div className="text-muted small">Trạng thái</div>
                                                        <div>
                                                            <span className="badge badge-info">
                                                                {mapTrangThaiYeuCauLabel(detailModalItem.status)}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-4 mb-0">
                                                        <div className="text-muted small">Mức độ ưu tiên</div>
                                                        <div>
                                                            <span className="badge badge-danger">
                                                                {mapMucDoUuTienLabel(detailModalItem.mucDo)}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-4 mb-0">
                                                        <div className="text-muted small">Mức độ phức tạp</div>
                                                        <div>
                                                            <span className="badge badge-success">
                                                                {mapMucDoPhucTapLabel(detailModalItem.mucDoPhucTap)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Phân công */}
                                        <div className="col-md-12 mb-3">
                                            <div className="border rounded p-3">
                                                <div className="text-uppercase text-muted small mb-2">Phân công</div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-2">
                                                        <div className="text-muted small">Người phối hợp</div>
                                                        <div className="font-weight-bold">
                                                            {getTenNguoiPhoiHop(detailModalItem.nguoiPhoiHopIds) || <span className="text-muted"></span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-0">
                                                        <div className="text-muted small">Nhân viên thực hiện</div>
                                                        <div className="font-weight-bold">
                                                            {getTenNhanVienThucHien(detailModalItem.nhanVienThucHienIds) || <span className="text-muted"></span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Nội dung + ghi chú */}
                                        <div className="col-md-12">
                                            <div className="border rounded p-3">
                                                <div className="text-uppercase text-muted small mb-2">Nội dung</div>
                                                <div className="mb-3" style={{ whiteSpace: 'pre-wrap' }}>
                                                    {detailModalItem.noiDung}
                                                </div>

                                                <div className="text-uppercase text-muted small mb-2">Ghi chú</div>
                                                <div style={{ whiteSpace: 'pre-wrap' }}>
                                                    {detailModalItem.ghiChu || <span className="text-muted"></span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                {/* ====== FILES ====== */}
                                <div className="mt-3">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <div className="text-uppercase text-muted small">Tệp đính kèm</div>
                                    </div>

                                    {Array.isArray(filesByYeuCau[detailModalItem.id]) && filesByYeuCau[detailModalItem.id].length > 0 ? (
                                        <div className="list-group">
                                            {filesByYeuCau[detailModalItem.id].map((f) => (
                                                <div
                                                    key={f.id}
                                                    className="list-group-item d-flex align-items-center justify-content-between"
                                                >
                                                    <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
                                                        <span className="mr-2 text-muted">📎</span>
                                                        <a
                                                            href={makeFileUrl(f.fileUrl || f.filePath || f.FileUrl || f.file)}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-truncate"
                                                            title={f.name || f.fileName || 'Tệp'}
                                                            style={{ maxWidth: 520 }}
                                                        >
                                                            {f.name || f.fileName || 'Tệp'}
                                                        </a>
                                                    </div>

                                                    <div className="d-flex align-items-center">
                                                        <button
                                                            className="btn btn-outline-primary btn-sm"
                                                            onClick={() => handleDownloadYeuCauFile(f)}
                                                        >
                                                            Tải xuống
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-muted">Không có tệp</div>
                                    )}
                                </div>
                            </div>
                        )}
                    </Modal.Body>

                    <Modal.Footer className="py-2">
                        <Button variant="secondary" size="sm" onClick={closeDetailModal}>
                            Đóng
                        </Button>
                    </Modal.Footer>
                </Modal>

            </div>

        </>
    );
};

export default YeuCau;
